"use client";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchInvoices } from "../../../services/billingService";
import { extractApiErrorMessage } from "../../../utils/error-handler";
import { formatPaise, formatBillingDate } from "../../../utils/billingFormat";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const SchoolInvoiceHistory = () => {
  const { schoolId } = useParams();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchInvoices(schoolId)
      .then((res) => setInvoices(res.data || []))
      .catch((err) => setError(extractApiErrorMessage(err)))
      .finally(() => setLoading(false));
  }, [schoolId]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h1 className="text-2xl font-bold text-gray-900">Invoices</h1>
        <Button variant="outline" onClick={() => navigate(`/dashboard/schools/${schoolId}/billing`)}>
          Back to Billing
        </Button>
      </div>

      {error && <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-red-700 text-sm">{error}</div>}

      <div className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-x-auto">
        {loading ? (
          <div className="py-16 text-center text-gray-400 text-sm">Loading...</div>
        ) : invoices.length === 0 ? (
          <div className="py-16 text-center text-gray-400 text-sm">No invoices yet.</div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Invoice #</TableHead>
                <TableHead>Amount</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Issued</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {invoices.map((inv) => (
                <TableRow key={inv._id}>
                  <TableCell>{inv.invoiceNumber}</TableCell>
                  <TableCell>{formatPaise(inv.totalAmount)}</TableCell>
                  <TableCell>
                    <Badge variant={inv.status === "ISSUED" ? "default" : "secondary"}>{inv.status}</Badge>
                  </TableCell>
                  <TableCell>{formatBillingDate(inv.issuedAt)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default SchoolInvoiceHistory;
